import React from 'react'
import styled from 'styled-components'
import colors from 'styles/colors'
import { universalLink } from 'constants/mobile-app'
import { trackGetApp } from 'tracking/pixel'

const Section = styled.section`
  padding: 90px 15px 40px;
  color: ${colors.white};
  background-color: ${colors.red};
  text-align: center;
`

const Title = styled.h3`
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 15px;
`

const Subtitle = styled.h3`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  & a,
  & a:hover,
  & a:focus {
    color: currentColor;
    text-decoration: underline;
  }
`

const AnimationContainer = () => (
  <Section>
    <Title>
      Your browser is not supported. Please update it or use another one.
    </Title>
    <Subtitle>
      or download the{' '}
      <a href={universalLink} onClick={trackGetApp}>
        Mobile app
      </a>
    </Subtitle>
  </Section>
)

export default AnimationContainer
